const faqs = [
  {
    id: 1,
    question: '天美麻花星空影视免费观看需要注册吗？',
    answer: '不需要。天美麻花星空影视免费观看完全开放，所有电影在线观看、电视剧免费、综艺节目等内容均可直接访问，无需注册登录即可畅享高清不缓冲的观影体验。',
  },
  {
    id: 2,
    question: '平台支持哪些设备观看？',
    answer: '天美麻花星空影视免费观看支持PC电脑、平板、手机等多种设备在线观看。影视视频资源经过多端适配优化，在不同屏幕尺寸上都能获得流畅的高清播放效果，随时随地畅享最新影视。',
  },
  {
    id: 3,
    question: '影片画质和播放流畅度如何？',
    answer: '平台采用先进的视频分发与压缩技术，提供高清画质的同时确保不缓冲的流畅播放。91电影视频、麻豆影视在线观看等频道均经过画质优化处理，在网络环境良好的情况下可达到1080P高清效果。',
  },
  {
    id: 4,
    question: '内容更新频率是怎样的？',
    answer: '天美麻花星空影视坚持每日更新策略，电影在线观看、电视剧免费、综艺节目等内容同步最新影视动态上线。热门剧集和院线大片通常在首播后较短时间内即可在平台找到，确保用户不落下任何精彩内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              关于天美麻花星空影视免费观看的常见疑问解答
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq) => (
              <details key={faq.id} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                    {faq.question}
                  </h3>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </summary>
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}